import { useMutation } from '@tanstack/react-query';

import reviewQuestionAnswerService from './reviewQuestionAnswerService';

import type { ReviewQuestionAnswer } from '@/types/review/ReviewAnswer';

import { ReviewQuestionAnswerMutationKey } from '@/constants/QueryKeys';

const useUpdateReviewQuestionAnswer = () => {
    return useMutation<ReviewQuestionAnswer, Error, ReviewQuestionAnswer>({
        mutationKey: [ReviewQuestionAnswerMutationKey.REVIEW_QUESTION_ANSWER],
        mutationFn: (reviewQuestionAnswer: ReviewQuestionAnswer) =>
            reviewQuestionAnswerService.updateReviewQuestionAnswer(reviewQuestionAnswer),
    });
};

const useCreateReviewQuestionAnswer = () => {
    return useMutation<ReviewQuestionAnswer, Error, ReviewQuestionAnswer>({
        mutationKey: [ReviewQuestionAnswerMutationKey.REVIEW_QUESTION_ANSWER],
        mutationFn: (reviewQuestionAnswer: ReviewQuestionAnswer) =>
            reviewQuestionAnswerService.createReviewQuestionAnswer(reviewQuestionAnswer),
    });
};

export { useUpdateReviewQuestionAnswer, useCreateReviewQuestionAnswer };
